import React, { useEffect, useState } from 'react';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { apiClient } from '@/api/client';
import { PropertyModel } from '@/models/property';

import {
	makeStyles,
	Paper,
	Typography,
	FormLabel,
	TextField,
	MenuItem,
	CircularProgress,
	Backdrop,
} from '@material-ui/core';

import { useDocumentTitle } from '@/hooks/use-document-title';
import AutomationMovedNotice from './AutomationMovedNotice';

const breadcrumbs = [
	{ label: 'houston', link: '/' },
	{ label: 'automation configuration', isActive: true },
];

const useStyles = makeStyles(theme => ({
	pageWrapper: {
		paddingTop: 30,
		[theme.breakpoints.up('md')]: {
			paddingLeft: 50,
			paddingRight: 50,
		},
		[theme.breakpoints.up('lg')]: {
			paddingLeft: 65,
			paddingRight: 65,
		},
		[theme.breakpoints.up('xl')]: {
			paddingLeft: 88,
			paddingRight: 88,
		},
		[theme.breakpoints.down('sm')]: {
			paddingTop: 20,
			paddingBottom: 20,
		},
	},
	topWrapper: {
		paddingLeft: '40px',
		'& .MuiTextField-root': {
			marginRight: theme.spacing(10),
			marginTop: theme.spacing(5),
		},
		'& h1': {
			fontSize: '25px',
		},
	},
	paper: {
		paddingTop: '35px',
		paddingBottom: '30px',
	},
	subCaption: {
		marginTop: '20px',
		color: 'black',
		fontSize: '16px',
	},
	propertyDropdown: {
		width: '440px',
	},
	table: {
		minWidth: 650,
	},
	tableContainer: {
		paddingLeft: '25px',
		paddingRight: '25px',
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#00000',
		opacity: '0.7',
	},
	backdropGridview: {
		background: 'none',
		position: 'relative',
	},
	noRecordMessage: {
		fontSize: '20px',
		textAlign: 'center',
	},
}));

const TaskConfigContainer = () => {
	const classes = useStyles();
	const [properties, setProperties] = useState<PropertyModel[]>();
	const [property, setProperty] = useState<PropertyModel>();
	const [isReady, setIsReady] = useState(false);

	useDocumentTitle('Automation Configurations');

	useEffect(() => {
		async function fetchProperties() {
			const properties = await apiClient.property.getAllProperties();

			setProperties(properties);
			setIsReady(true);

			if (properties.length === 0) {
				return;
			}

			setProperty(properties[0]);
		}

		fetchProperties();
	}, []);

	return (
		<div className={classes.pageWrapper}>
			<PageContainer heading='Automation configurations' breadcrumbs={breadcrumbs}>
				<Paper component="div" className={classes.paper}>
					<div className={classes.topWrapper}>

						{isReady === false &&
							<Backdrop className={classes.backdrop} open={!isReady}>
								<CircularProgress color="inherit" />
							</Backdrop>
						}

						{<>
							<FormLabel className={classes.subCaption} component="legend">
								<Typography variant="h6" component="h6">
									Select property
								</Typography>
							</FormLabel>

							{properties && property
								? <TextField
									name="propertyId"
									select
									variant="outlined"
									fullWidth
									className={classes.propertyDropdown}
									onChange={e => setProperty(properties.find(property => property.id === e.target.value))}
									value={property?.id}
								>
									{properties?.map(property => (
										<MenuItem key={property.id} value={property.id}>
											{property.name}
										</MenuItem>
									))}
								</TextField>
								: null}
						</>}

						{property?.id === undefined ? null : (
							<AutomationMovedNotice propertyId={property?.id} />
						)}
					</div>
				</Paper>
			</PageContainer>
		</div>
	);
};

export default TaskConfigContainer
